import { Card, Stack, Title, H3, Tooltip } from "@introist/react-foundation/v2";
import styled from "styled-components";

const EllipsisTitle = styled(Title)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

interface MetricsCardProps {
  title: string;
  value: string | number;
  tooltip?: string;
}

export const MetricsCard = ({ title, value, tooltip }: MetricsCardProps) => {
  return (
    <Card>
      <Stack vertical alignItems="center" style={{ maxWidth: "250px", minWidth: "150px" }}>
        <Tooltip tooltip={tooltip || title}>
          <EllipsisTitle>{title}</EllipsisTitle>
        </Tooltip>
        <H3>{value}</H3>
      </Stack>
    </Card>
  );
};
